// Fallback labels for annotations nobody renamed — "Distance 1", "Area 2".
// `position` is 1-based and comes from the caller's own list; `t` is passed in
// so each caller keeps its reactivity to locale changes.

// sidebar.area carries a trailing space, which HTML collapses but a cell keeps.
const numbered = (key, position, t) => `${t(key).trim()} ${position}`;

export const defaultDistanceName = (position, t) =>
  numbered("sidebar.distance", position, t);

export const defaultAreaName = (position, t) =>
  numbered("sidebar.area", position, t);

export const defaultPvArrayName = (position, t) =>
  numbered("sidebar.pvArray", position, t);
